interface FlagIconProps {
  countryCodes: string[];
}

export const FlagIcon = ({ countryCodes }: FlagIconProps) => {
  return countryCodes.map((code) => {
    return <span className={`fi inline-block mr-2 fi-${code}`} key={code} />;
  });
};
